module.exports = __webpack_public_path__ + "static/size-debdf294dd27c941985c025b40326589.jpg";